import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=28113fe5&scoped=true&"
import script from "./monitor.vue?vue&type=script&lang=js&"
export * from "./monitor.vue?vue&type=script&lang=js&"
import style0 from "./monitor.vue?vue&type=style&index=0&id=28113fe5&lang=scss&scoped=true&"
import style1 from "./monitor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28113fe5",
  null
  
)

export default component.exports